import React, { useState } from "react";
import { Box, Card, Typography, CardContent, Grid, Divider } from "@material-ui/core";
import UseWindowDimensions from "../../../common/utils/getWindowDimensions";
import { CameraRoute } from "../camera.routes";
import { useStyles } from "./style";
import TabHeader from "../../../components/TabHeader/TabHeader";
import CommonButton from "src/components/CommonButton/CommonButton";
import CameraIcon from "@material-ui/icons/CameraAlt";
import { useDispatch } from "react-redux";
import { cameraURL, loader } from "src/app-redux/camera/cameraSlice";
import { getCameraStreamAction } from "src/app-redux/camera/actions/cameraActions";
import { useAppSelector } from "src/app-redux/hooks";
import Backdrop from "@material-ui/core/Backdrop";
import CommonLoader from "src/components/Loader/CommonLoader";

interface Props {}

export function CameraStream({}: Props): React.ReactElement {
  const loading: any = useAppSelector(loader);
  const URL: any = useAppSelector(cameraURL);

  const dispatch = useDispatch();
  const classes = useStyles();
  const [moduleName] = useState<any>(CameraRoute.title);
  const [pageHeading] = useState<any>(CameraRoute.title);

  const { height } = UseWindowDimensions();
  let wHeight = 0;
  // let gridMaxHeight = 0;
  // let dppr = 10;
  wHeight = height - 132;
  // gridMaxHeight = height - 200;
  // if (height > 700 && height < 900) {
  //   dppr = 15;
  // } else if (height > 900) {
  //   dppr = 25;
  // } else {
  //   dppr = 10;
  // }

  const openCameraStream = () => {
    window.open(URL.cameraStream, "_blank", "width=1300,height=600,left=150,top=100");
  };

  React.useEffect(() => {
    void dispatch(getCameraStreamAction());
  }, [dispatch]);

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} />
      <Backdrop className={classes.backdrop} open={loading}>
        <CommonLoader />
      </Backdrop>
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain} style={{ height: wHeight }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={8}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}>{pageHeading}</Typography>
              </Box>
            </Grid>
          </Grid>
          <Divider />
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={12}>
              <Box marginTop={20} textAlign={"center"}>
                <CommonButton cssClass="customSubmitBtn" isGreen onClick={() => openCameraStream()}>
                  <CameraIcon /> <span style={{ marginLeft: "10px" }}>Camera Stream</span>
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
